/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const C = {
  bg: 'rgba(8,12,30,0.60)',
  kant: 'rgba(255,255,255,0.08)',
  tekst: '#e2e8f0',
  subtekst: '#7a8fa6',
  success: '#22c55e',
  info: '#3b82f6',
  warning: '#f59e0b',
  danger: '#ef4444',
};

const FARVER = ['#3b82f6', '#22c55e', '#f59e0b', '#8b5cf6', '#ef4444', '#3fd4c7', '#ec4899'];

const TYPE_LABELS = {
  boernebidrag: 'Børnebidrag',
  friplads: 'Friplads',
  boligstoette: 'Boligstøtte',
  tilskud: 'Tilskud',
};

const api = async (sti) => {
  const res = await fetch('/api' + sti, { credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export default function BeregnerSegmenteringDSPanel() {
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(true);
  const [fejl, setFejl] = useState(null);
  const [sorter, setSorter] = useState('antal');

  useEffect(() => {
    api('/os/ds/beregner-segmentering')
      .then(d => { setData(d); setLoader(false); })
      .catch(e => { setFejl(e.message); setLoader(false); });
  }, []);

  if (loader) return <div style={{ padding: 32, color: C.subtekst, textAlign: 'center' }}>Henter segmenteringsdata…</div>;
  if (fejl) return <div style={{ padding: 32, color: '#ef4444' }}>Fejl: {fejl}</div>;
  if (!data) return null;

  const pieData = (data.typer || []).map((t, i) => ({
    name: TYPE_LABELS[t.type] || t.type,
    value: t.antal,
    farve: FARVER[i % FARVER.length],
  }));

  const segmenter = [...(data.segmenter || [])].sort((a, b) =>
    sorter === 'antal' ? b.antal - a.antal : a.type.localeCompare(b.type)
  );

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, color: C.tekst, fontSize: 20, fontWeight: 800 }}>Beregner-bruger Segmentering</h2>
          <div style={{ fontSize: 12, color: C.subtekst, marginTop: 4 }}>
            Seneste 30 dage · {data.total || 0} sessioner i alt
          </div>
        </div>
        {data.dominerende_segment && (
          <div style={{
            background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.3)',
            borderRadius: 8, padding: '4px 12px', fontSize: 12, fontWeight: 700, color: C.info,
            maxWidth: 280, textAlign: 'right',
          }}>
            Dominerende: {data.dominerende_segment}
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 250px', minWidth: 250, background: C.bg, border: `1px solid ${C.kant}`, borderRadius: 12, padding: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.tekst, marginBottom: 8 }}>Fordeling per type</div>
          {pieData.length === 0 ? (
            <div style={{ color: C.subtekst, fontSize: 13, padding: 20, textAlign: 'center' }}>
              Ingen data for de seneste 30 dage
            </div>
          ) : (
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={55} outerRadius={85} dataKey="value" paddingAngle={3}>
                  {pieData.map((entry, i) => (
                    <Cell key={i} fill={entry.farve} />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{ background: '#0a0f23', border: `1px solid ${C.kant}`, borderRadius: 8, fontSize: 12 }}
                  formatter={(value, name) => [value + ' sessioner', name]}
                />
                <Legend wrapperStyle={{ fontSize: 12, color: C.subtekst }} />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>

        <div style={{ flex: '2 1 300px', minWidth: 300 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: C.tekst }}>Top segmenter</div>
            <div style={{ display: 'flex', gap: 6 }}>
              {['antal', 'type'].map(s => (
                <button key={s} onClick={() => setSorter(s)} style={{
                  background: sorter === s ? 'rgba(59,130,246,0.20)' : 'rgba(255,255,255,0.04)',
                  border: `1px solid ${sorter === s ? 'rgba(59,130,246,0.4)' : 'rgba(255,255,255,0.08)'}`,
                  color: sorter === s ? C.info : C.subtekst,
                  borderRadius: 6, padding: '3px 10px', fontSize: 11, fontWeight: 600, cursor: 'pointer',
                }}>
                  {s === 'antal' ? 'Antal' : 'Type'}
                </button>
              ))}
            </div>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr>
                  {['Type', 'Indkomstinterval', 'Børn', 'Antal'].map(h => (
                    <th key={h} style={{ textAlign: 'left', padding: '8px 10px', fontSize: 11, color: C.subtekst, fontWeight: 700, borderBottom: `1px solid ${C.kant}`, whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {segmenter.slice(0, 15).map((s, i) => (
                  <tr key={i} style={{ borderBottom: `1px solid rgba(255,255,255,0.04)` }}>
                    <td style={{ padding: '7px 10px', color: C.tekst, fontWeight: 600 }}>{TYPE_LABELS[s.type] || s.type}</td>
                    <td style={{ padding: '7px 10px', color: C.subtekst }}>{s.indkomst_interval || '—'}</td>
                    <td style={{ padding: '7px 10px', color: C.subtekst }}>{s.antal_born || '—'}</td>
                    <td style={{ padding: '7px 10px', color: C.info, fontWeight: 700 }}>{s.antal}</td>
                  </tr>
                ))}
                {segmenter.length === 0 && (
                  <tr>
                    <td colSpan={4} style={{ padding: '20px 10px', textAlign: 'center', color: C.subtekst }}>
                      Ingen segmentdata for perioden
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
